// Decouverte des solutions PAR MOTIF (spec 133, FR-005).
//
// `import.meta.glob` est resolu par Vite a la construction : il produit des imports statiques vers
// chaque `src/solutions/*/register.tsx` trouve. Le socle ne nomme donc AUCUNE solution — il declare
// seulement ou les chercher. Ajouter une solution = poser son dossier ; aucun fichier du socle ne
// change (FR-006).
//
// Le module est importe pour son EFFET DE BORD : chaque `register.tsx` charge appelle
// `registerSolution` a l'evaluation. Il doit donc etre importe AVANT toute lecture du registre —
// c'est le role de `main.tsx`, racine de composition.
//
// ⚠️ Ne pas remplacer ce glob par des imports nommes « pour la lisibilite » : ce serait
// reintroduire dans le socle la connaissance des solutions, que le controle C2 refuse.

const modules = import.meta.glob('/src/solutions/*/register.tsx', { eager: true })

/** Nombre de solutions decouvertes. Zero est suspect : le motif ne trouve plus rien. */
export const discoveredSolutionCount = Object.keys(modules).length

if (import.meta.env.DEV && discoveredSolutionCount === 0) {
  console.warn(
    '[solutions] aucune solution decouverte sous src/solutions/*/register.tsx — ' +
      'navigation et routes de solution seront vides.',
  )
}
